import { useRef, useEffect, useCallback } from "react";
import { useEffectEvent } from "../use-effect-event";

export function useDebounce<T extends (...args: any[]) => any>(
  callback: T,
  delay: number,
): T {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const stableCallback = useEffectEvent(callback);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return useCallback(
    ((...args) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        stableCallback(...args);
      }, delay);
    }) as T,
    [delay, stableCallback],
  );
}
